import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=03e54bd6&scoped=true&"
import script from "./AreaTable.vue?vue&type=script&lang=js&"
export * from "./AreaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e54bd6",
  null
  
)

export default component.exports